import { PointService } from '../../utils/common/point.service';
import { SizeService } from '../../utils/common/size.service';
import { FixedPositionType } from '../../../element-setting/shared/display/fixed-position-type';
import { LocalizationService } from 'abp-ng2-module/src/localization/localization.service';
import { AppConsts } from '../../../../../shared/AppConsts';
import { LocalizationHelper } from '../../../../../shared/helpers/localization-helper';
import * as go from '../../../../../libs/gojs/release/go';
var ElementBase = /** @class */ (function () {
    function ElementBase(injector) {
        this.sizeService = injector.get(SizeService);
        this.pointService = injector.get(PointService);
        this.localizationService = injector.get(LocalizationService);
    }
    ElementBase.prototype.build = function (part, svg) {
        var data = part.data;
        var model = { id: part.data.key, category: part.category };
        this.buildConditionalDisplayData(model, data);
        this.compile(model, data, svg);
        return model;
    };
    ElementBase.prototype.handleElementFinished = function (_obj, _svg) {
    };
    ElementBase.prototype.buildConditionalDisplayData = function (model, data) {
        // conditional display
        model['isAwaysDisplay'] = data.isAwaysDisplay;
        if (!data.isAwaysDisplay) {
            model['isDisplayControl'] = data.displayLogicEnabled;
            model['conditionItems'] = data.conditionItems;
            if (data.permissionsForDisplaySetting) {
                model['isDisplayPermission'] = data.permissionsForDisplaySetting.PermissionEnabled;
                model['displayPermissionCodes'] = data.permissionsForDisplaySetting.PermissionList;
            }
        }
    };
    ElementBase.prototype.l = function (key) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return LocalizationHelper.l(this.localizationService, AppConsts.localization.configureLocalizationSourceName, key, args);
    };
    ElementBase.prototype.getFixedPositionType = function (data) {
        var fixedPositionType = data.fixedPositionType !== undefined ? data.fixedPositionType : 0;
        var strokeWidth = data.strokeWidth ? Number(data.strokeWidth) : 0;
        var width, height;
        if (data.width && data.height) {
            width = Number(data.width);
            height = Number(data.height);
        }
        else if (data.size && data.size.indexOf(' ') > 0) {
            var sizeInfo = data.size.split(' ');
            width = sizeInfo[0], height = sizeInfo[1];
            width = Number(width);
            height = Number(height);
        }
        var x = 0, y = 0;
        if (strokeWidth && strokeWidth > 0 && width && height && width > 0 && height > 0) {
            x = strokeWidth / (strokeWidth + width) / 2;
            y = strokeWidth / (strokeWidth + height) / 2;
        }
        var locationSpot;
        switch (fixedPositionType) {
            case FixedPositionType.TopLeft:
                locationSpot = new go.Spot(go.Spot.TopLeft.x + x, go.Spot.TopLeft.y + y);
                break;
            case FixedPositionType.TopCenter:
                locationSpot = new go.Spot(go.Spot.TopCenter.x, go.Spot.TopCenter.y + y);
                break;
            case FixedPositionType.TopRight:
                locationSpot = new go.Spot(go.Spot.TopRight.x - x, go.Spot.TopRight.y + y);
                break;
            case FixedPositionType.CenterLeft:
                locationSpot = new go.Spot(go.Spot.LeftCenter.x + x, go.Spot.LeftCenter.y);
                break;
            case FixedPositionType.CenterCenter:
                locationSpot = go.Spot.Center;
                break;
            case FixedPositionType.CenterRight:
                locationSpot = new go.Spot(go.Spot.RightCenter.x - x, go.Spot.RightCenter.y);
                break;
            case FixedPositionType.BottomLeft:
                locationSpot = new go.Spot(go.Spot.BottomLeft.x + x, go.Spot.BottomLeft.y - y);
                break;
            case FixedPositionType.BottomCenter:
                locationSpot = new go.Spot(go.Spot.BottomCenter.x, go.Spot.BottomCenter.y - y);
                break;
            case FixedPositionType.BottomRight:
                locationSpot = new go.Spot(go.Spot.BottomRight.x - x, go.Spot.BottomRight.y - y);
                break;
            default:
                locationSpot = new go.Spot(go.Spot.TopLeft.x + x, go.Spot.TopLeft.y + y);
                break;
        }
        return locationSpot;
    };
    return ElementBase;
}());
export { ElementBase };
